var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { E_STATUS } from '../types';
import { COLORS } from '../styles/colors';
import { windowExist } from 'src/shared/constants';
import * as PDFJS from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';
PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export var onClickOutside = function (element, callback, exception) {
    if (exception === void 0) { exception = []; }
    var registerToClick = function (event) {
        if (element &&
            element.current &&
            !element.current.contains(event.target) &&
            exception.indexOf(event.target.className) === -1 &&
            typeof callback === 'function') {
            callback();
        }
    };
    if (windowExist) {
        document.addEventListener('click', registerToClick);
        return function () { return document.removeEventListener('click', registerToClick); };
    }
};
export var getColorByStatus = function (status) {
    switch (status) {
        case E_STATUS.OK:
            return COLORS.GREEN['500'];
        case E_STATUS.KO:
            return COLORS.RED['500'];
        case E_STATUS.UNKNOWN:
        default:
            return COLORS.ORANGE['500'];
    }
};
var onImageLoad = function (imageSrc) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.src = imageSrc;
        image.onload = function () { return resolve(image); };
        image.onerror = function (error) { return reject(error); };
    });
};
export var rotateBase64 = function (imageBase64, clockwiseRotation) {
    var canvas = document.createElement('canvas');
    var contextCanvas = canvas.getContext('2d');
    var indexOfPreBase64Image = imageBase64.indexOf(';base64,');
    var typeOfBase64 = imageBase64.substring(5, indexOfPreBase64Image);
    // Check if the image is a valid base64
    if (!typeOfBase64) {
        return Promise.reject(null);
    }
    return onImageLoad(imageBase64)
        .then(function (image) {
        canvas.height = image.width;
        canvas.width = image.height;
        if (clockwiseRotation) {
            contextCanvas.rotate((90 * Math.PI) / 180);
            contextCanvas.translate(0, -canvas.width);
        }
        else {
            contextCanvas.rotate((-90 * Math.PI) / 180);
            contextCanvas.translate(-canvas.height, 0);
        }
        contextCanvas.drawImage(image, 0, 0);
        return canvas.toDataURL(typeOfBase64, 100);
    })
        .catch(function (error) {
        return Promise.reject(null);
    });
};
export var renderPDFPage = function (pdf, pageNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var SOURCE_SCALE, MIN_TARGET_WIDTH, MAX_TARGET_WIDTH, canvas, canvasContext, page, sourceViewport, pageWidth, targetWidth, targetScale, targetViewport, image;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                SOURCE_SCALE = 1;
                MIN_TARGET_WIDTH = 1280;
                MAX_TARGET_WIDTH = 1600;
                canvas = document.createElement('canvas');
                canvasContext = canvas.getContext('2d');
                return [4 /*yield*/, pdf.getPage(pageNumber)];
            case 1:
                page = _a.sent();
                sourceViewport = page.getViewport({ scale: SOURCE_SCALE });
                pageWidth = sourceViewport.width;
                targetWidth = Math.max(MIN_TARGET_WIDTH, Math.min(MAX_TARGET_WIDTH, pageWidth));
                targetScale = targetWidth / pageWidth;
                targetViewport = page.getViewport({ scale: targetScale });
                // Set dimensions of canvas view size of page
                canvas.height = targetViewport.height;
                canvas.width = targetViewport.width;
                return [4 /*yield*/, page.render({ canvasContext: canvasContext, viewport: targetViewport }).promise];
            case 2:
                _a.sent();
                image = canvas.toDataURL('image/png');
                return [2 /*return*/, image];
        }
    });
}); };
export var convertPdfToImage = function (documentPDF) { return __awaiter(void 0, void 0, void 0, function () {
    var pages_1, pdf, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                pages_1 = [];
                pdf = PDFJS.getDocument(documentPDF);
                return [4 /*yield*/, pdf.promise.then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                        var numberOfPages, i, page;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    numberOfPages = res.numPages;
                                    i = 1;
                                    _a.label = 1;
                                case 1:
                                    if (!(i <= numberOfPages)) return [3 /*break*/, 4];
                                    return [4 /*yield*/, renderPDFPage(res, i)];
                                case 2:
                                    page = _a.sent();
                                    pages_1.push(page);
                                    _a.label = 3;
                                case 3:
                                    i++;
                                    return [3 /*break*/, 1];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })];
            case 1:
                _a.sent();
                return [2 /*return*/, pages_1];
            case 2:
                e_1 = _a.sent();
                throw new Error('Error while converting pdf to image');
            case 3: return [2 /*return*/];
        }
    });
}); };
